"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandTextController = void 0;
var ExpandTextController = /** @class */ (function () {
    function ExpandTextController(buttonRowBlock) {
        this.buttonRowBlock = buttonRowBlock;
        this.attachEvents();
        this.collapseAllSections();
    }
    ExpandTextController.collapseSection = function (element) {
        var _a, _b;
        var CONTENT_LINE_HEIGHT_IN_PX = 24;
        var NUMBER_OF_VISIBLE_LINES_WHEN_COLLAPSED = 3;
        element.style.height = "".concat(element.scrollHeight, "px");
        element.getBoundingClientRect();
        requestAnimationFrame(function () {
            element.style.height = "".concat(CONTENT_LINE_HEIGHT_IN_PX * NUMBER_OF_VISIBLE_LINES_WHEN_COLLAPSED, "px");
        });
        element.classList.add(ExpandTextController.isCollapsedClassName);
        // Update button text from read less to read more
        (_b = (_a = element
            .closest(ExpandTextController.componentWrapperQuerySelector)) === null || _a === void 0 ? void 0 : _a.querySelector(ExpandTextController.buttonRowQuerySelector)) === null || _b === void 0 ? void 0 : _b.classList.remove(ExpandTextController.isCollapsedClassName);
    };
    ExpandTextController.expandSection = function (element) {
        var _a, _b;
        var height = element.scrollHeight;
        element.classList.remove(ExpandTextController.isCollapsedClassName);
        element.style.height = "".concat(height, "px");
        element.addEventListener('transitionend', function () {
            element.style.height = '';
        }, { once: true });
        // Update button text from read more to read less
        (_b = (_a = element
            .closest(ExpandTextController.componentWrapperQuerySelector)) === null || _a === void 0 ? void 0 : _a.querySelector(ExpandTextController.buttonRowQuerySelector)) === null || _b === void 0 ? void 0 : _b.classList.add(ExpandTextController.isCollapsedClassName);
    };
    ExpandTextController.prototype.attachEvents = function () {
        var expandTextBlock = this.buttonRowBlock.querySelector(ExpandTextController.expandTextQuerySelector);
        var collapseTextBlock = this.buttonRowBlock.querySelector(ExpandTextController.collapseTextQuerySelector);
        expandTextBlock === null || expandTextBlock === void 0 ? void 0 : expandTextBlock.addEventListener('click', function (event) {
            var _a;
            var target = event.target;
            var targetSection = (_a = target
                .closest(ExpandTextController.componentWrapperQuerySelector)) === null || _a === void 0 ? void 0 : _a.querySelector(ExpandTextController.contentQuerySelector);
            targetSection && ExpandTextController.expandSection(targetSection);
        });
        collapseTextBlock === null || collapseTextBlock === void 0 ? void 0 : collapseTextBlock.addEventListener('click', function (event) {
            var _a;
            var target = event.target;
            var targetSection = (_a = target
                .closest(ExpandTextController.componentWrapperQuerySelector)) === null || _a === void 0 ? void 0 : _a.querySelector(ExpandTextController.contentQuerySelector);
            targetSection && ExpandTextController.collapseSection(targetSection);
        });
    };
    ExpandTextController.prototype.collapseAllSections = function () {
        document.querySelectorAll(ExpandTextController.contentQuerySelector).forEach(function (section) {
            ExpandTextController.collapseSection(section);
        });
    };
    ExpandTextController.componentWrapperQuerySelector = '.js-content-teaser';
    ExpandTextController.buttonRowQuerySelector = '.js-button-holder';
    ExpandTextController.expandTextQuerySelector = '.js-expand-text';
    ExpandTextController.collapseTextQuerySelector = '.js-collapse-text';
    ExpandTextController.contentQuerySelector = '.js-expand-text-content';
    ExpandTextController.isCollapsedClassName = 'is-collapsed';
    return ExpandTextController;
}());
exports.ExpandTextController = ExpandTextController;
